export const SECTION_COLORS = [
  { bg: 'var(--color-neutral)', text: 'var(--color-base-100)' },
  { bg: 'var(--color-base-200)', text: 'var(--color-neutral)' },
  { bg: 'var(--color-base-100)', text: 'var(--color-neutral)' },
];